/**
 * Coleta do Mercado Livre: a transportadora do ML retira o pacote aqui na TAGA.
 * Vem de `envio.logistica_ml`, o `logistic_type` do shipment gravado pelo sync
 * de vendas (cross_docking = coleta, xd_drop_off = agência, self_service = flex).
 */
export const isColetaMl = (envio) => envio?.logistica_ml === 'cross_docking';

/**
 * Rótulo do modo de envio no /despacho. As opções do filtro, o filtro em si e o
 * agrupamento dos cards usam este mesmo texto: se um deles montar diferente, a
 * opção escolhida no filtro não encontra nenhum pedido.
 */
export const labelModoEnvio = (envio) => {
    const modo = envio?.modo_envio || 'Outros';
    if (envio?.flex_ml === 1) return `${modo} - FLEX`;
    if (isColetaMl(envio)) return `${modo} - COLETA`;
    return modo;
};
